import MyTabs from '../../components/MyTabs';
import Archive from './Archive';
import { Library } from './Library';

const ResearchCentre = (props) => {
  
    const tabs = [
        { id: "library", title: "Library" , Component: Library},
        { id: "archive", title: "Archive", Component: Archive },
      ];

return (
    <>
        <MyTabs list={tabs}/>
    </>
)
};

export default ResearchCentre;